/*
 * Editors with unsaved work register a check here, so the things that would
 * throw that work away (switching project tabs, the back button) can ask
 * first. A check returns a sentence saying what isn't saved, or null.
 */
type UnsavedWorkCheck = () => string | null;

const checks = new Set<UnsavedWorkCheck>();

// Returns the function that unregisters it.
export function registerUnsavedWork(check: UnsavedWorkCheck): () => void {
    checks.add(check);
    return () => {
        checks.delete(check);
    };
}

// What isn't saved yet, or null when everything is.
export function unsavedWork(): string | null {
    for (const check of checks) {
        const message = check();
        if (message) {
            return message;
        }
    }
    return null;
}
